import { Subscription } from '@pollination-solutions/pollination-sdk'

/**
 * Determines if a subscription is using the new billing system or legacy system
 * based on the subscription ID format.
 * 
 * New billing subscriptions have string IDs (from Paddle Billing API)
 * Legacy subscriptions have integer IDs (from old system)
 */
export const isNewBillingSubscription = (subscription: Subscription): boolean => {
  if (!subscription.external_id) return false

  // Check if the ID is a string that's not a pure number
  // New billing IDs are typically UUIDs or other string formats
  const id = subscription.external_id.toString()

  // If it's purely numeric, it's legacy
  if (/^\d+$/.test(id)) {
    return false
  }

  // If it contains non-numeric characters, it's new billing
  return true
}

export const isInvoiceSubscription = (subscription: Subscription): boolean => {
  if (!subscription.external_id) return false
  const id = subscription.external_id.toString()

  // Invoice subscriptions have a specific prefix in their external_id
  return id.startsWith('invoice')
}